import { globalErrorHandler } from './global-error.handler';

export default async (): Promise<void> => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */

  const productCardsElem = document.querySelector("agl-spa-shell[spa-id='app-product-cards']");
  const isGuidedFlow = document.querySelector('bundle-builder');
  if (productCardsElem && !isGuidedFlow) {
    productCardsElem.classList.add('app-product-cards--with-skeleton-loader');
    const skeletonLoader = document.createElement('div');
    skeletonLoader.classList.add('product-cards-skeleton-load');

    const addCard = () => {
      const card = document.createElement('div');
      const cardTitle = document.createElement('div');
      cardTitle.classList.add('product-cards-skeleton-load__card-title');
      card.appendChild(cardTitle);
      card.classList.add('product-cards-skeleton-load__card');
      const cardSubTitle = document.createElement('div');
      cardSubTitle.classList.add('product-cards-skeleton-load__card-subtitle');
      card.appendChild(cardSubTitle);
      card.appendChild(document.createElement('div'));
      card.appendChild(document.createElement('div'));
      card.appendChild(document.createElement('div'));
      card.appendChild(document.createElement('div'));
      const cardButton = document.createElement('div');
      cardButton.classList.add('product-cards-skeleton-load__card-button');
      card.appendChild(cardButton);
      skeletonLoader.appendChild(card);
    };

    addCard();
    addCard();
    addCard();
    productCardsElem.appendChild(skeletonLoader);
  }

  await globalErrorHandler();
};
